var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.$t("navbar.seeImage"),
            visible: _vm.dialogVisibleImage,
            top: "3vh",
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleImage = $event
            },
          },
        },
        [
          _c("div", [
            _vm.imageList.length > 0
              ? _c(
                  "div",
                  { staticStyle: { width: "500px" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          color: "#409eff",
                          "font-size": "18px",
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.currentIndex + 1))]),
                        _c("span", [_vm._v("/")]),
                        _c("span", [_vm._v(_vm._s(_vm.imageList.length))]),
                      ]
                    ),
                    _c(
                      "el-carousel",
                      {
                        ref: "carousel",
                        attrs: { height: "750px", trigger: "click" },
                        on: { change: _vm.handlecarousel },
                      },
                      _vm._l(_vm.imageList, function (item) {
                        return _c("el-carousel-item", { key: item }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "10px" } },
                            [
                              _c("el-image", {
                                staticStyle: { width: "100%", height: "700px" },
                                attrs: {
                                  "preview-src-list": [item],
                                  src: item,
                                  fit: "fill",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      width: "500px",
                      "text-align": "center",
                      height: "750px",
                    },
                  },
                  [
                    _c("el-image", { staticStyle: { width: "100%" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-picture-outline",
                            staticStyle: { "font-size": "30px" },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }